class RTLHeader extends HTMLElement {
  connectedCallback() {
    this.productsTrigger = this.querySelector('[data-rtl-products-trigger]');
    this.megaMenu = this.querySelector('[data-rtl-mega-menu]');
    this.mobileToggle = this.querySelector('[data-rtl-mobile-toggle]');
    this.mobileDrawer = this.querySelector('[data-rtl-mobile-drawer]');
    this.searchToggle = this.querySelector('[data-rtl-search-toggle]');
    this.search = this.querySelector('[data-rtl-search]');

    this.productsTrigger?.addEventListener('click', () => this.toggleMega());
    this.mobileToggle?.addEventListener('click', () => this.openMobile());
    this.querySelectorAll('[data-rtl-mobile-close]').forEach((button) => button.addEventListener('click', () => this.closeMobile()));
    this.mobileDrawer?.addEventListener('click', (event) => { if (event.target === this.mobileDrawer) this.closeMobile(); });
    this.searchToggle?.addEventListener('click', () => {
      this.search?.classList.toggle('is-open');
      this.search?.querySelector('input')?.focus();
    });
    this.querySelectorAll('[data-rtl-menu-category]').forEach((button) => button.addEventListener('click', () => this.selectCategory(button)));
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.closeMega();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { this.closeMega(); this.closeMobile(); }
    });
  }

  toggleMega() {
    const open = !this.megaMenu?.classList.contains('is-open');
    this.megaMenu?.classList.toggle('is-open', open);
    this.productsTrigger?.setAttribute('aria-expanded', String(open));
  }

  closeMega() {
    this.megaMenu?.classList.remove('is-open');
    this.productsTrigger?.setAttribute('aria-expanded', 'false');
  }

  selectCategory(button) {
    const key = button.dataset.rtlMenuCategory;
    this.querySelectorAll('[data-rtl-menu-category]').forEach((item) => item.classList.remove('is-active'));
    this.querySelectorAll('[data-rtl-menu-panel]').forEach((panel) => panel.classList.remove('is-active'));
    button.classList.add('is-active');
    this.querySelector(`[data-rtl-menu-panel="${CSS.escape(key)}"]`)?.classList.add('is-active');
  }

  openMobile() {
    this.mobileDrawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closeMobile() {
    this.mobileDrawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

if (!customElements.get('rtl-header')) customElements.define('rtl-header', RTLHeader);

class RTLVideoHero extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('[data-rtl-hero-video]');
    this.toggle = this.querySelector('[data-rtl-hero-toggle]');
    if (!this.video || !this.toggle) return;

    this.toggle.addEventListener('click', () => {
      if (this.video.paused) {
        this.video.play().then(() => this.updateState(false)).catch(() => this.updateState(true));
      } else {
        this.video.pause();
        this.updateState(true);
      }
    });

    this.video.addEventListener('pause', () => this.updateState(true));
    this.video.addEventListener('play', () => this.updateState(false));

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.video.pause();
      this.updateState(true);
    }
  }

  updateState(paused) {
    this.classList.toggle('is-paused', paused);
    this.toggle?.setAttribute('aria-pressed', String(paused));
    this.toggle?.setAttribute('aria-label', paused ? 'Reproduzir vídeo' : 'Pausar vídeo');
  }
}

if (!customElements.get('rtl-video-hero')) customElements.define('rtl-video-hero', RTLVideoHero);

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-rtl-buy-now]');
  if (!button || button.disabled || button.dataset.loading === 'true') return;

  const form = button.closest('form');
  const productArea = button.closest('[id^="ProductInfo-"]') || button.closest('product-component');
  const variantInput = form?.querySelector('input[name="id"]');
  const quantityInput = productArea?.querySelector('input[name="quantity"]');
  const variantId = Number(variantInput?.value);
  const quantity = Math.max(1, Number(quantityInput?.value) || 1);
  if (!variantId) return;

  const originalText = button.textContent;
  button.dataset.loading = 'true';
  button.disabled = true;
  button.textContent = 'Processando…';

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    if (!response.ok) throw new Error('Não foi possível adicionar o produto.');

    const minimumOrder = Number(button.dataset.minimumOrder) || 0;
    if (minimumOrder > 0) {
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Não foi possível verificar o valor do carrinho.');
      const cart = await cartResponse.json();
      window.location.assign(cart.total_price >= minimumOrder ? `${root}checkout` : `${root}cart`);
    } else {
      window.location.assign(`${root}checkout`);
    }
  } catch (error) {
    button.disabled = false;
    button.dataset.loading = 'false';
    button.textContent = originalText;
    window.alert(error.message || 'Não foi possível iniciar a compra. Tente novamente.');
  }
});
